"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersDetail = void 0;
require("./orders-detail.less");
const React = require("react");
const ReactDOMServer = require("react-dom/server");
const ReactTooltip = require("react-tooltip");
const moment = require("moment");
const order_1 = require("shared/order");
const claim_1 = require("shared/claim");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const dispense_hover_status_1 = require("./components/dispense-hover-status");
const dispense_scan_1 = require("./components/dispense-scan");
const dispense_1 = require("./tabs/dispense");
const floating_page_1 = require("client/components/page/floating-page");
const permissions_1 = require("shared/permissions");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const store_1 = require("client/modules/users/store");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const menu_1 = require("client/components/material/menu");
const select_1 = require("client/components/material/select");
const toolbar_1 = require("client/components/material/toolbar");
const Menu_1 = require("material-ui/Menu");
const payment_1 = require("./tabs/payment");
const router_1 = require("client/components/router");
const alert_1 = require("client/components/ui/alert");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const text_button_1 = require("client/components/ui/text-button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/orders/store");
const store_3 = require("client/modules/app-settings/store");
const store_4 = require("client/modules/providers/store");
const store_5 = require("../../../../modules/inventory-order/store"); //D-002.8
const patient_payment_balance_1 = require("shared/patient-payment-balance");
let OrdersDetail = class OrdersDetail extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.dispenseScan = false;
        this.aboutToDispense = false;
        this.aboutToRequest = false;
        this.doNotDispense = false;
        this.changedClaims = [];
        this.selectedClaims = [];
        this.checkedAllClaims = false;
        this.indeterminateClaims = false;
        this.noClaimsSelected = false;
        this.printModal = false;
        this.isRefill = false;
        this.isError = false;
        this.cancelReason = null;
        this.cancelReasonMulti = {};
        this.provider = null;
        this.patientHasSigned = true;
        this.isSaving = false;
        this.containsMixStatus = false;
        this.useSameReason = true;
        this.allowCompanyForEsign = false; // C-108
        this.allowUsersForEsign = false; // C-108
        this.allowCompanyPatientAmt = false; // D-002.8
        this.allowPharmacySetting = false; // D-002.810
        this.orderClaimsComponent = React.createRef();
        this.closePrintPreview = () => {
            this.printModal = false;
        };
        this.handleDispenseScanSubmit = async (submitMetas) => {
            const { order: { value: { claims } } } = store_2.ordersStore;
            // claims with signatures
            const signedClaims = claims.filter(c => c.signature);
            for (const scannedInventory of submitMetas) {
                const [ndc, lotsArray] = scannedInventory;
                const claimFound = signedClaims.find(c => c.inventory.package === ndc);
                if (claimFound) {
                    console.info("Claim found with pkg ", ndc);
                    console.info("Proceeding to attempt claim lot update");
                    const lots = lotsArray.map((lotData) => {
                        const [lotNumber, parsedBarcodeArray] = lotData;
                        return {
                            lotNumber,
                            qty: parsedBarcodeArray ? parsedBarcodeArray.length : 0
                        };
                    });
                    const siteId = this.order.site.id;
                    await store_2.ordersStore.updateClaimDispenseScan(claimFound, lots, siteId);
                    // update selected claims
                    const index = this.selectedClaims.findIndex(c => c.id === claimFound.id);
                    index === -1 && this.selectedClaims.push(claimFound);
                    this.updateNumCheckedClaims();
                }
                else {
                    console.error(`No claim found with inventory with pkg ${ndc}. Cannot update claim lot with scanned data`);
                }
            }
            this.dispenseScan = false;
            // Refresh UI
            if (this.orderClaimsComponent && this.orderClaimsComponent.current) {
                this.changedClaims = [];
                this.orderClaimsComponent.current.resetChangedClaims();
            }
            const order = this.getOrder();
            await store_2.ordersStore.loadClaims(order.id);
            await store_2.ordersStore.readOrder(order.id);
        };
        this.handlePadSelectProvider = (pad) => {
            store_4.providersStore.promptSignature(pad, this.provider);
            this.padsOpen = undefined;
            const { signature } = this.provider;
            this.signatureInterval = window.setInterval(async () => {
                // console.log("signature interval in ... provider triggered");
                const provider = await store_4.providersStore.readProvider(this.provider.id);
                if (provider && signature !== provider.signature) {
                    store_4.providersStore.loadProviders();
                    this.provider.signature = provider.signature;
                    window.clearInterval(this.signatureInterval);
                }
            }, 2500);
        };
        this.handleMobilePadSelectPatient = async (pad) => {
            if (this.order) {
                const firstSelected = this.selectedClaims[0];
                const oldSignature = firstSelected.signature;
                await store_2.ordersStore.promptMobileSignature(pad, this.selectedClaims, this.order);
                this.padsOpen = undefined;
                let hooked = false;
                const forceClear = () => window.clearInterval(this.mobileSignatureInterval);
                forceClear();
                this.mobileSignatureInterval = window.setInterval(async () => {
                    if (hooked)
                        forceClear();
                    const claim = await store_2.ordersStore.readClaim(firstSelected.id);
                    const newSignature = claim && claim.signature;
                    if (claim && oldSignature !== newSignature) {
                        if (!hooked)
                            hooked = true;
                        forceClear();
                        for (const changedClaim of this.selectedClaims) {
                            changedClaim.signature = claim.signature;
                            await store_2.ordersStore.updateClaim(changedClaim);
                        }
                        await store_2.ordersStore.loadClaims(this.order.id);
                    }
                }, 2500);
            }
        };
        this.handlePadSelectPatient = async (pad) => {
            if (this.order) {
                const firstSelected = this.selectedClaims[0];
                const oldSignature = firstSelected.signature;
                await store_2.ordersStore.promptSignature(pad, this.selectedClaims, this.order);
                this.padsOpen = undefined;
                let hooked = false;
                const forceClear = () => window.clearInterval(this.signatureInterval);
                forceClear();
                this.signatureInterval = window.setInterval(async () => {
                    if (hooked)
                        forceClear();
                    const claim = await store_2.ordersStore.readClaim(firstSelected.id);
                    const newSignature = claim === null || claim === void 0 ? void 0 : claim.signature;
                    if (claim && oldSignature !== newSignature) {
                        if (!hooked)
                            hooked = true;
                        forceClear();
                        for (const changedClaim of this.selectedClaims) {
                            changedClaim.signature = claim.signature;
                            await store_2.ordersStore.updateClaim(changedClaim);
                        }
                        await store_2.ordersStore.loadClaims(this.order.id);
                    }
                }, 2500);
            }
        };
        this.handlePadSelectBill = (pad) => {
            if (this.order) {
                const firstSelected = this.selectedClaims[0];
                store_2.ordersStore.promptSignature(pad, this.selectedClaims, this.order, true);
                this.padsOpen = undefined;
                const oldSignature = this.order.billSignature;
                this.signatureInterval = window.setInterval(async () => {
                    const claim = await store_2.ordersStore.readClaim(firstSelected.id);
                    const newOrder = claim === null || claim === void 0 ? void 0 : claim.order;
                    const newSignature = newOrder === null || newOrder === void 0 ? void 0 : newOrder.billSignature;
                    if (newOrder && oldSignature !== newSignature) {
                        window.clearInterval(this.signatureInterval);
                    }
                }, 2500);
            }
        };
        this.onClickPadsProvider = (event) => {
            store_4.providersStore.loadActivePads(this.provider);
            this.padsOpen = event.currentTarget;
        };
        this.onClickPadsPatient = (event) => {
            if (store_1.usersStore.user.value.groupId === 4) {
                store_2.ordersStore.loadActiveMobilePads(this.order);
            }
            else {
                store_2.ordersStore.loadActivePads(this.order);
            }
            this.padsOpen = event.currentTarget;
        };
        this.onClosePads = () => {
            this.padsOpen = undefined;
        };
        /**
         * @desc Checks whether an order has been audited and approved; if not then it
         * passes the user (a physician) to the request modal, otherwise it passes them
         * to the dispense modal.
         */
        this.onClickProcess = async (order) => {
            this.auditStatus = order.auditStatus;
            this.noClaimsSelected = this.selectedClaims.length === 0;
            // B-148 — Pending Approve with no Rx checked must not dispense/void (B2 all)
            if (this.auditStatus === order_1.AuditStatus.Pending &&
                this.selectedClaims.length === 0) {
                return;
            }
            if (this.auditStatus === order_1.AuditStatus.Unsubmitted) {
                this.aboutToRequest = true;
            }
            if (this.auditStatus === order_1.AuditStatus.Pending) {
                this.updateClaimData();
            }
            if (this.auditStatus === order_1.AuditStatus.Approved) {
                this.aboutToDispense = true;
            }
        };
        /**
         * @author MD
         * @desc Handles updating the order to a state where it's ready to be audited
         * by IMB staff before being approved or declined.
         */
        this.onClickRequest = () => {
            this.onClickDispense();
            this.aboutToRequest = false;
        };
        this.onClickCancelRequest = () => {
            this.aboutToRequest = false;
        };
        /**
         * @desc Handles passing the order through the dispense process for distributing
         * medication to the patient.
         */
        this.onClickDispense = async () => {
            const order = this.getOrder();
            const success = await store_2.ordersStore.dispenseOrder(order);
            if (success) {
                if (this.copayCollectionEnabled) {
                    await store_2.ordersStore.refreshOrderDetail(order.id, false);
                }
                else {
                    await store_2.ordersStore.loadClaims(order.id, null, false, true);
                }
            }
            else {
                alert("dispensed claim unsuccessful");
            }
            this.aboutToDispense = false;
            this.selectedClaims = [];
            this.checkedAllClaims = false;
            this.order = store_2.ordersStore.order.value;
            const dispensedClaims = this.order.claims.filter((clm) => clm.status === claim_1.ClaimStatus.Dispensed);
            // .map((clm: IClaim) => clm.id);
            // Save our claim pdfs.
            await store_2.ordersStore.print(dispensedClaims, "saveToDB");
        };
        this.onClickCancelDispense = () => {
            this.aboutToDispense = false;
        };
        this.onClickDoNotDispense = () => {
            this.doNotDispense = true;
        };
        this.onClickCancelDoNotDispense = () => {
            this.doNotDispense = false;
        };
        this.onClickConfirmDoNotDispense = async () => {
            this.doNotDispense = false;
            const order = {
                id: Number(this.props.params[0]),
                claims: []
            };
            const logData = {
                user: store_1.usersStore.user.value.id,
                action: "Clicked cancel order.",
                category: store_1.LogCategory.order,
                categoryReferenceKey: order.id,
                order: order.id,
                site: store_2.ordersStore.order.value.site.id
            };
            await store_1.usersStore.createLog(logData);
            if (!this.cancelReason &&
                Object.keys(this.cancelReasonMulti).length === 0) {
                this.cancelReason = "Reasons";
            }
            const success = await store_2.ordersStore.dispenseOrder(order, false, this.cancelReason ? this.cancelReason : this.cancelReasonMulti);
            if (success) {
                await store_2.ordersStore.loadClaims(order.id);
            }
        };
        // * EVENTS: CLAIMS
        this.indeterminate = () => this.indeterminateClaims;
        this.isAllClaimsChecked = () => this.checkedAllClaims;
        this.isClaimChecked = (claim) => Boolean(this.selectedClaims.find(c => c.id === claim.id));
        this.handleCheckAllClaims = () => {
            const order = store_2.ordersStore.order.value;
            let claims = [];
            if (order === null || order === void 0 ? void 0 : order.claims) {
                claims =
                    order.status === order_1.OrderStatus.Done ||
                        order.status === order_1.OrderStatus.Refilled
                        ? order.claims.filter(claim => claim.status === claim_1.ClaimStatus.Dispensed ||
                            claim.status === claim_1.ClaimStatus.Reversed)
                        : order.claims;
            }
            if (this.checkedAllClaims) {
                this.selectedClaims = [];
            }
            else {
                this.selectedClaims = [];
                for (const claim of claims) {
                    if (claim.status === claim_1.ClaimStatus.Paid) {
                        claim.siteId = order.site.id;
                        this.selectedClaims.push(claim);
                    }
                }
            }
            this.checkedAllClaims = !this.checkedAllClaims;
            this.updateNumCheckedClaims();
        };
        this.handleClaimChanged = (claims) => {
            this.changedClaims = claims;
        };
        this.handleClaimSelected = (claim) => {
            const index = this.selectedClaims.findIndex(c => c.id === claim.id);
            index === -1
                ? this.selectedClaims.push(claim)
                : this.selectedClaims.splice(index, 1);
            this.updateNumCheckedClaims();
        };
        this.updateClaimData = async () => {
            const claims = this.changedClaims;
            for (const claim of claims) {
                await store_2.ordersStore.updateClaim(claim);
            }
            await this.onClickDispense();
        };
        this.updateNumCheckedClaims = () => {
            const order = store_2.ordersStore.order.value;
            let claims = [];
            let numClaimsPaid = 0;
            if (order === null || order === void 0 ? void 0 : order.claims) {
                claims =
                    order.status === order_1.OrderStatus.Done ||
                        order.status === order_1.OrderStatus.Refilled
                        ? order.claims.filter(claim => claim.status === claim_1.ClaimStatus.Dispensed ||
                            claim.status === claim_1.ClaimStatus.Reversed)
                        : order.claims;
            }
            claims.map(claim => {
                if (claim.status === claim_1.ClaimStatus.Paid) {
                    numClaimsPaid++;
                }
            });
            if (this.selectedClaims.length === 0) {
                this.indeterminateClaims = false;
                this.checkedAllClaims = false;
            }
            else if (this.selectedClaims.length === numClaimsPaid) {
                this.indeterminateClaims = false;
                this.checkedAllClaims = true;
            }
            else {
                this.indeterminateClaims = true;
            }
        };
        // * EVENTS: PRINT
        this.onClickPrintModalCancel = () => {
            this.printModal = false;
        };
        this.printLabelsClickHandler = async (type) => {
            // this.onClickPrintModalCancel();
            const dispensedClaims = this.order.claims.filter((clm) => clm.status === claim_1.ClaimStatus.Dispensed);
            // .map((clm: IClaim) => clm.id);
            this.printModal = true;
            await store_2.ordersStore.print(dispensedClaims, type);
            const logData = {
                user: store_1.usersStore.user.value.id,
                action: `Clicked "print ${type} documents".`,
                category: store_1.LogCategory.order,
                categoryReferenceKey: this.order.id,
                order: this.order.id,
                site: this.order.site.id
            };
            await store_1.usersStore.createLog(logData);
        };
        this.handleCopayBtn = async (event) => {
            // D-002.8
            event.preventDefault(); // Prevent default navigation
            const newTabUrl = `${window.location.pathname}/payment`;
            window.open(newTabUrl, '_blank');
        };
        // * EVENTS: REFILLS
        this.onClickProcessRefill = async (order) => {
            const { claims } = order;
            const refill = claims.find((claim) => {
                if (claim.status === claim_1.ClaimStatus.Refill)
                    return claim;
            });
        };
        // * ----------========== REGION: Functional Code ==========----------
        this.updateAuditStatus = (status) => {
            this.order.auditStatus = status;
            store_2.ordersStore.updateOrder(this.order);
        };
        // * ----------========== REGION: Component Rendering ==========----------
        this.renderAlertRefill = (order) => {
            const refillAlert = (React.createElement("span", null,
                "This refill ",
                React.createElement("strong", null, "can't be processed"),
                " and requires attention!",
                React.createElement("p", null,
                    "Please take one of the following courses of action:",
                    React.createElement("ul", null,
                        React.createElement("li", null, "Resolve the error and retry the claim."),
                        React.createElement("li", null, "Find an alternative medication."),
                        React.createElement("li", null, "Cancel the claim.")))));
            this.isError = order.status === order_1.OrderStatus.Error;
            this.isRefill = order.refill;
            if (this.isError && this.isRefill) {
                store_2.ordersStore.errorAlert = refillAlert;
            }
        };
        this.handleCreatePad = () => {
            // console.log("pad create triggered");
        };
        // C-108.7 — Print to Sign / e-Sign bypass; B-148 keep Rx checkboxes after refresh
        this.isBypassSignature = async (reson) => {
            var _a;
            const order = store_2.ordersStore.order.value;
            let claimIdArray = [];
            let claims = [];
            if (order === null || order === void 0 ? void 0 : order.claims) {
                claims =
                    order.status === order_1.OrderStatus.Done ||
                        order.status === order_1.OrderStatus.Refilled
                        ? order.claims.filter(claim => claim.status === claim_1.ClaimStatus.Dispensed ||
                            claim.status === claim_1.ClaimStatus.Reversed)
                        : order.claims;
            }
            for (const claim of claims) {
                if (claim.status === claim_1.ClaimStatus.Paid) {
                    claim.siteId = order.site.id;
                    claimIdArray.push(claim.id);
                }
            }
            // B-148 — remember checked Rxs across signature mode change + claim reload
            const previouslySelectedIds = this.selectedClaims.map(c => c.id);
            if (reson === 'print_to_Sign') {
                await store_2.ordersStore.signatureBypass(claimIdArray, "print_to_Sign");
            }
            if (reson === 'e_Sign') {
                await store_2.ordersStore.signatureBypass(claimIdArray, "e_Sign");
            }
            const orderId = Number(this.props.params[0]);
            await store_2.ordersStore.loadClaims(orderId, undefined, true, true);
            const refreshedClaims = ((_a = store_2.ordersStore.order.value) === null || _a === void 0 ? void 0 : _a.claims) || [];
            this.selectedClaims = previouslySelectedIds
                .map(id => refreshedClaims.find(c => c.id === id))
                .filter((c) => Boolean(c));
            this.updateNumCheckedClaims();
        };
        // C-108
        this.handleSwitch = (e) => {
            this.currentDropValue = e.target.value;
            this.isBypassSignature(e.target.value); // C-108.7
        };
        this.renderPatientSignatureAlert = () => {
            var _a, _b, _c, _d, _e;
            const newOrder = (_a = store_2.ordersStore === null || store_2.ordersStore === void 0 ? void 0 : store_2.ordersStore.order) === null || _a === void 0 ? void 0 : _a.value;
            const signedClaims = [];
            const unsignedClaims = [];
            this.selectedClaims.forEach((claim) => {
                claim.signature ? signedClaims.push(claim) : unsignedClaims.push(claim);
            });
            const hasSigned = signedClaims.length > 0;
            const hasUnsigned = unsignedClaims.length > 0;
            const renderNames = () => this.selectedClaims.map((claim) => (React.createElement("li", { key: claim.id },
                React.createElement("span", { style: unsignedClaims.includes(claim)
                        ? { color: "red" }
                        : { color: "green" } },
                    "#",
                    claim.id,
                    " -",
                    " ",
                    claim.inventory.strengthDescription || claim.inventory.name))));
            const readyToSignMeds = (newOrder === null || newOrder === void 0 ? void 0 : newOrder.auditStatus) === order_1.AuditStatus.Pending &&
                (newOrder === null || newOrder === void 0 ? void 0 : newOrder.status) === order_1.OrderStatus.Ready;
            return (this.order &&
                readyToSignMeds && (React.createElement(React.Fragment, null,
                hasUnsigned && (React.createElement(alert_1.UiAlert, { title: "Approved to Dispense", type: "warning", message: `One of the following medications didn't receive a signature from the patient; please request a new signature.` })),
                React.createElement("div", { className: "patient-signature" },
                    React.createElement("div", { className: "patient-signature__column" }, (!(((_c = (_b = this.order) === null || _b === void 0 ? void 0 : _b.site) === null || _c === void 0 ? void 0 : _c.allowSiteForESign) && this.allowCompanyForEsign) || this.currentDropValue === "e_Sign") &&
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "label text" },
                                "Accepted by ",
                                this.order.patient.firstName,
                                " ",
                                this.order.patient.lastName),
                            React.createElement("div", { className: "pads" },
                                React.createElement("div", { className: "dummy-pad" },
                                    React.createElement("div", { className: "dummy-pad__label" }, "Patient Signature"),
                                    !hasUnsigned && hasSigned && (React.createElement("img", { alt: "Patient Signature", className: "signature", src: signedClaims[0].signature })),
                                    React.createElement("div", { className: "dummy-pad__baseline" })),
                                hasUnsigned && unsignedClaims[0].id > 0 && (React.createElement(text_button_1.UiTextButton, { secondary: true, onClick: this.onClickPadsPatient }, "Get Patient's Signature")),
                                React.createElement(menu_1.MaterialMenu, { open: Boolean(this.padsOpen), onClose: this.onClosePads, anchorEl: this.padsOpen }, this.getPadSelector())))),
                    React.createElement("div", { className: "patient-signature__column", style: { display: 'inline-grid' } }, renderNames && (React.createElement(React.Fragment, null,
                        (((_e = (_d = this.order) === null || _d === void 0 ? void 0 : _d.site) === null || _e === void 0 ? void 0 : _e.allowSiteForESign) && this.allowCompanyForEsign) && (React.createElement(React.Fragment, null,
                            React.createElement(React.Fragment, null, "Collecting Patients Signature"),
                            React.createElement("select", { style: { padding: '6px' }, onChange: this.handleSwitch, value: this.currentDropValue },
                                React.createElement("option", { value: "e_Sign" }, "e-Sign"),
                                React.createElement("option", { value: "print_to_Sign" }, "Print to Sign")))),
                        React.createElement("p", null, renderNames()))))))));
        };
        this.renderPadSelection = () => (React.createElement("div", { className: "pads" },
            React.createElement("span", { style: { fontWeight: 300 } },
                "Authorized by ",
                this.provider.prefix,
                " ",
                this.provider.firstName,
                " ",
                this.provider.lastName,
                " ",
                this.provider.suffix),
            React.createElement("div", { className: "dummy-pad" },
                this.provider.signature && (React.createElement("img", { src: this.provider.signature, className: "signature" })),
                React.createElement("div", { className: "dummy-pad__baseline" })),
            React.createElement(text_button_1.UiTextButton, { secondary: true, onClick: this.onClickPadsProvider }, "Update Signature"),
            React.createElement(menu_1.MaterialMenu, { open: Boolean(this.padsOpen), onClose: this.onClosePads, anchorEl: this.padsOpen },
                (!store_4.providersStore.pads.value ||
                    store_4.providersStore.pads.value.length === 0) && (React.createElement(Menu_1.MenuItem, { onClick: this.handleCreatePad },
                    React.createElement("a", { className: "pad-create-menu-link", href: "/pad", target: "__blank" }, "Click to create"))),
                store_4.providersStore.pads.value &&
                    store_4.providersStore.pads.value.map((p, index) => (React.createElement(Menu_1.MenuItem, { key: index, onClick: () => this.handlePadSelectProvider(p) }, p.name))))));
        this.renderBillSignature = () => {
            const newOrder = store_2.ordersStore.order.value ? store_2.ordersStore.order.value : "";
            const readyToSignBill = newOrder && newOrder.auditStatus === order_1.AuditStatus.Approved;
            const signature = newOrder
                ? newOrder.billSignature
                : this.order.billSignature;
            return (this.order &&
                readyToSignBill && (React.createElement("div", { className: "pads" },
                React.createElement("span", { style: { fontWeight: 300 } }),
                React.createElement("div", { className: "dummy-pad" },
                    React.createElement("div", { className: "dummy-pad__label" }, "Billing Signature"),
                    signature && React.createElement("img", { src: signature, className: "signature" }),
                    React.createElement("div", { className: "dummy-pad__baseline" })),
                React.createElement(text_button_1.UiTextButton, { secondary: true, onClick: this.onClickPadsPatient }, "Get Patient's Signature"),
                React.createElement(menu_1.MaterialMenu, { open: Boolean(this.padsOpen), onClose: this.onClosePads, anchorEl: this.padsOpen },
                    (!store_2.ordersStore.pads.value ||
                        store_2.ordersStore.pads.value.length === 0) && (React.createElement(Menu_1.MenuItem, null, "No Signature Pads Found")),
                    store_2.ordersStore.pads.value &&
                        store_2.ordersStore.pads.value.map((p, index) => (React.createElement(Menu_1.MenuItem, { key: index, onClick: () => this.handlePadSelectBill(p) }, p.name)))))));
        };
        this.stepBackStatus = async () => {
            await store_2.ordersStore.stepBack(this.order.id);
            await store_2.ordersStore.readOrder(this.order.id);
        };
        /** D-002.272 — shared with payment tab via patient-payment-balance.ts */
        this.renderStatus = (order) => {
            const auditUnsubmitted = order.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = order.auditStatus === order_1.AuditStatus.Pending;
            const paymentComplete = this.isPaymentComplete;
            const isDev = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            // Determine the status message
            let statusMessage = "";
            if (order.status === order_1.OrderStatus.Ready) {
                statusMessage = auditUnsubmitted
                    ? "Ready for Provider Review"
                    : auditPending
                        ? "Approved to Dispense"
                        : "Ready To Dispense";
            }
            else if (order.status === order_1.OrderStatus.Pending) {
                statusMessage = "Pending Adjudication";
            }
            else if (order.status === order_1.OrderStatus.Progress ||
                order.status === order_1.OrderStatus.Executing) {
                statusMessage = "In Progress";
            }
            else if (order.status === order_1.OrderStatus.Reversed) {
                statusMessage = "Canceled";
            }
            else if (order.status === order_1.OrderStatus.Intended) {
                statusMessage = paymentComplete ? "Intend to Dispense" : "Patient Payment Due";
            }
            else if (order.status === order_1.OrderStatus.Error) {
                statusMessage = order.refill ? "Refill Error" : "Error";
            }
            else if (order.status === order_1.OrderStatus.ReverseError) {
                statusMessage = isDev ? "Failed to Reverse" : "Pending Reversal";
            }
            else if (order.status === order_1.OrderStatus.Refill) {
                statusMessage = paymentComplete ? "Refill Due" : "Patient Payment Due";
            }
            else if (order.status === order_1.OrderStatus.Refilled) {
                statusMessage = paymentComplete ? "Dispensed and Refilled" : "Patient Payment Due";
            }
            else if (order.status === order_1.OrderStatus.Done) {
                statusMessage = paymentComplete ? "Dispensed" : "Patient Payment Due";
            }
            return (React.createElement("div", { className: "orders-detail__status-row" },
                React.createElement("div", { className: `orders-detail__status orders-detail__status--${order.status}
            ${(order.status === order_1.OrderStatus.Done || order.status === order_1.OrderStatus.Refilled || order.status === order_1.OrderStatus.Refill || order.status === order_1.OrderStatus.Intended) && !paymentComplete
                        ? "orders-detail__status--due-payment"
                        : ""}` }),
                React.createElement("div", { className: "orders-detail__status-text" }, statusMessage)));
        };
        /**
         * Author: tkay
         * Objective: Build react tool tip hover html content to show the criteria flags
         * for the dispense meds button and determine ready to dispense
         *
         * 01/29/20 md: Need to add a warning for selected items without signatures
         * due to the new dispense-view; it's possible to reach this page without
         * signatures.
         */
        this.determineDispense = meta => {
            const { order, loading, isUnsubmitted, isPending, isApproved, hasDispensed, isIntended, isDone, isRefill, isReversed, ispendingCopayAmt, } = meta;
            // B-148 — empty selection must not count as "all signed" (Array.every on [] is true)
            const haveSignatures = this.selectedClaims.length > 0 &&
                this.selectedClaims.every(claim => Boolean(claim.signature));
            const calculateNominalQty = (claim) => {
                const siteId = claim.order ? claim.order.site.id : claim.siteId;
                const siteInventory = claim.inventory.sites.find(inventorySite => inventorySite.siteId === siteId &&
                    inventorySite.inventoryId === claim.inventory.id);
                const expiredLots = (siteInventory === null || siteInventory === void 0 ? void 0 : siteInventory.inventorySiteLots) ? siteInventory.inventorySiteLots.filter((invSiteLot) => {
                    const expDate = moment(invSiteLot.expirationDate);
                    const expired = moment().isAfter(expDate);
                    return expired;
                })
                    : [];
                const inventorysiteQuantity = siteInventory ? siteInventory.quantity : 0;
                const totalExpiredLotsQty = expiredLots.reduce((cur, acc) => {
                    if (acc === null || acc === void 0 ? void 0 : acc.quantity) {
                        return cur + Number(acc.quantity);
                    }
                    return cur;
                }, 0);
                const inventorysiteQuantityNominal = inventorysiteQuantity - totalExpiredLotsQty;
                return {
                    inventorysiteQuantityNominal,
                    totalExpiredLotsQty,
                    inventorysiteQuantity
                };
            };
            const enoughInventoryQty = this.selectedClaims.every(claim => {
                const { inventorysiteQuantityNominal } = calculateNominalQty(claim);
                const canDispense = inventorysiteQuantityNominal >= claim.quantity;
                return canDispense;
            });
            const validLots = this.selectedClaims.every(claim => {
                const match = this.changedClaims.find(c => c.id === claim.id);
                let { claimLots, quantity: claimQuantity } = match !== null && match !== void 0 ? match : claim;
                claimLots = claimLots || [];
                let validExpirationDates = true;
                let validClaimLots = false;
                for (const claimLot of claimLots) {
                    const expirationDateIsAfterToday = !moment(claimLot.siteLot.expirationDate).isBefore(moment(new Date()));
                    if (!expirationDateIsAfterToday) {
                        validExpirationDates = false;
                        break;
                    }
                }
                const totalSelectedLotsQuantity = claimLots.reduce((acc, curr) => acc + Number(curr.qtyUsed), 0);
                validClaimLots =
                    totalSelectedLotsQuantity >= claimQuantity && validExpirationDates;
                const { inventorysiteQuantityNominal } = calculateNominalQty(claim);
                return inventorysiteQuantityNominal > claim.quantity
                    ? validClaimLots
                    : true;
            });
            const notLoading = !loading;
            const claimSelected = Boolean(this.selectedClaims.length);
            const isDev = store_1.usersStore.user.value.groupId === 4;
            const today = moment().startOf("day");
            let isExpired = false;
            if (this.provider) {
                isExpired =
                    moment(today).isSameOrAfter(this.provider.deaExp) ||
                        moment(today).isSameOrAfter(this.provider.stateLicenseExp);
            }
            const canUserPrescribe = isDev ||
                (order.site.id === 1 && store_1.usersStore.user.value.admin) ||
                !order.site.assignedProviders ||
                (!!this.provider &&
                    !!this.provider.userId &&
                    store_1.usersStore.user.value.id === this.provider.userId &&
                    !isExpired);
            const dispenseCondition = haveSignatures && isApproved && claimSelected && validLots;
            const pendingCondition = haveSignatures && isPending && claimSelected; // D-002.890;
            const unsubmittedCondition = isUnsubmitted && claimSelected && canUserPrescribe;
            const readyForDispense = notLoading &&
                (unsubmittedCondition || pendingCondition || dispenseCondition);
            const invalidUser = order && isUnsubmitted && !canUserPrescribe;
            if (!isDev) {
                return {
                    readyForDispense,
                    dispenseHoverHtml: invalidUser
                        ? "Only the prescribing physician can dispense medication."
                        : ""
                };
            }
            const dispenseHoverHtml = ReactDOMServer.renderToString(React.createElement(dispense_hover_status_1.DispenseHoverStatus, { loading: loading, isUnsubmitted: isUnsubmitted, isPending: isPending, isApproved: isApproved, haveSignatures: haveSignatures, claimSelected: claimSelected, enoughQty: enoughInventoryQty, validLots: validLots, readyForDispense: readyForDispense, hasDispensed: !!hasDispensed, isIntended: isIntended, isDone: isDone, isRefill: isRefill, isReversed: isReversed, ispendingCopayAmt: ispendingCopayAmt }));
            return { readyForDispense, dispenseHoverHtml };
        };
        this.handleBarcodeScan = () => {
            this.dispenseScan = true;
        };
        this.renderFooter = () => {
            if (!store_2.ordersStore.order.value)
                return;
            const order = store_2.ordersStore.order.value;
            const claims = order === null || order === void 0 ? void 0 : order.claims;
            const orderStatus = order === null || order === void 0 ? void 0 : order.status;
            const auditStatus = order === null || order === void 0 ? void 0 : order.auditStatus;
            const hasDispensed = claims === null || claims === void 0 ? void 0 : claims.find((clm) => clm.status === claim_1.ClaimStatus.Dispensed);
            const isRefill = order && orderStatus === order_1.OrderStatus.Refill;
            const isIntended = order && orderStatus === order_1.OrderStatus.Intended;
            const isDone = order &&
                (orderStatus === order_1.OrderStatus.Done ||
                    orderStatus === order_1.OrderStatus.Refilled ||
                    orderStatus === order_1.OrderStatus.Reversed);
            const isUnsubmitted = order && auditStatus === order_1.AuditStatus.Unsubmitted;
            const isApproved = order && auditStatus === order_1.AuditStatus.Approved;
            const isPending = order && auditStatus === order_1.AuditStatus.Pending;
            const isReversed = order && orderStatus === order_1.OrderStatus.Reversed;
            const loading = store_2.ordersStore.order.loading ||
                (order &&
                    (orderStatus === order_1.OrderStatus.Progress ||
                        orderStatus === order_1.OrderStatus.Executing));
            // D-002.810 — copay satisfied (used for dev dispense hover diagnostics)
            const copaySatisfied = this.copayCollectionEnabled && this.isPaymentComplete;
            const determineDispenseMeta = {
                order,
                loading,
                isUnsubmitted,
                isPending,
                isApproved,
                hasDispensed: Boolean(hasDispensed),
                isIntended,
                isDone,
                isRefill,
                isReversed,
                ispendingCopayAmt: copaySatisfied //D-002.810
            };
            const canUserDispense = store_1.usersStore.user.value.admin ||
                (!!this.provider &&
                    !!this.provider.userId &&
                    store_1.usersStore.user.value.id === this.provider.userId);
            const dispenseWarning = (!isPending &&
                !isUnsubmitted &&
                !canUserDispense &&
                "Only the prescribing physician can dispense.") ||
                "";
            const { readyForDispense, dispenseHoverHtml } = this.determineDispense(determineDispenseMeta);
            const isAllIntentClaims = order.claims &&
                order.claims.every((claim) => claim.status === claim_1.ClaimStatus.Intended ||
                    claim.status === claim_1.ClaimStatus.Reversed);
            const isSomeIntentClaims = order.claims &&
                order.claims.some((claim) => claim.status === claim_1.ClaimStatus.Intended);
            const isMixedClaims = isSomeIntentClaims &&
                order.claims &&
                order.claims.some((claim) => this.checkReversableStatus(claim.status));
            // console.info("allIntentClaims", isAllIntentClaims);
            // console.info("isMixedClaims", isMixedClaims);
            return (this.route &&
                String(this.route.path) === String(/^\/claims\/(\d+)$/) && (React.createElement("div", { className: "orders-detail__footer" },
                React.createElement(toolbar_1.MaterialToolBar, null,
                    hasDispensed && store_1.usersStore.permissions.ReadPrint && (React.createElement(React.Fragment, null,
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: () => this.printLabelsClickHandler("all") }, "Print Documents"),
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: () => this.printLabelsClickHandler("labels") }, "Print Labels"))),
                    hasDispensed &&
                        this.copayCollectionEnabled &&
                        !this.isPaymentComplete && (React.createElement(React.Fragment, null,
                        React.createElement(button_1.MaterialButton, { primary: true, 
                            // disabled={!readyForDispense && this.paymentsInfo?.length}
                            onClick: e => this.handleCopayBtn(e) }, "Patient Payment"))),
                    !isDone && store_1.usersStore.permissions.CreateClaims && (React.createElement(React.Fragment, null,
                        !isUnsubmitted && !isPending && (React.createElement(button_1.MaterialButton, { disabled: loading, onClick: this.handleBarcodeScan }, "Scan")),
                        !isUnsubmitted &&
                            !isPending &&
                            store_1.usersStore.permissions.ReadErrors && (React.createElement(button_1.MaterialButton, { disabled: loading, onClick: this.stepBackStatus }, "Step Back to Signature")),
                        !isAllIntentClaims ? (React.createElement(button_1.MaterialButton, { disabled: loading, onClick: isMixedClaims
                                ? () => {
                                    this.containsMixStatus = true;
                                    this.onClickDoNotDispense();
                                }
                                : () => {
                                    this.containsMixStatus = false;
                                    this.onClickDoNotDispense();
                                } }, isRefill ? "Cancel Refill" : "Cancel Claim")) : null,
                        React.createElement("div", { "data-for": "dispensebtn", "data-tip": dispenseHoverHtml, "data-html": true },
                            React.createElement(button_1.MaterialButton, { primary: true, disabled: !readyForDispense, onClick: () => this.onClickProcess(order) }, isUnsubmitted
                                ? "Request Dispense"
                                : isPending
                                    ? "Approve Selection"
                                    : "Dispense Meds"))))),
                this.renderModalCancelClaim(),
                this.renderModalBeforeDispense(),
                this.renderModalBeforeRequest(),
                this.renderModalPendingAudit(),
                this.renderModalPrint())));
        };
        this.checkReversableStatus = (claimStatus) => claimStatus === claim_1.ClaimStatus.Error ||
            claimStatus === claim_1.ClaimStatus.Paid ||
            claimStatus === claim_1.ClaimStatus.ReverseError ||
            claimStatus === claim_1.ClaimStatus.ReverseErrorDev;
        // * ----------========== REGION: Modal Rendering ==========----------
        this.renderModalPendingAudit = () => {
            if (this.order && this.order.auditStatus === order_1.AuditStatus.Pending) {
                // console.log("Order is pending");
            }
        };
        this.handleCancelReasonSelect = (value) => {
            this.cancelReason = value;
        };
        this.renderModalCancelClaim = () => {
            var _a, _b;
            const isDev = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            const reasonValues = (_b = (_a = this.cancellationReasons) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.filter(obj => {
                const shouldReturn = !isDev ? obj.editable : true;
                if (shouldReturn)
                    return obj;
            });
            const reasons = reasonValues === null || reasonValues === void 0 ? void 0 : reasonValues.map((cancellation, i) => ({
                id: i,
                label: cancellation.reason,
                value: cancellation.reason
            }));
            if (!this.order)
                return;
            const paidClaims = this.order.claims.filter((claim) => claim.status === claim_1.ClaimStatus.Paid ? claim : false);
            console.log(this.order.claims);
            const renderReason = (React.createElement(React.Fragment, null,
                this.useSameReason ? (React.createElement(select_1.MaterialSelect, { label: "Reason for Canceling", required: true, value: this.cancelReason || "", onSelect: this.handleCancelReasonSelect, searchable: true, options: reasons })) : (React.createElement("div", { style: {
                        // Sorry, I got too lazy to make a class while testing. :(
                        border: "1px dashed grey",
                        padding: "1em",
                        width: "100%",
                        height: "12em",
                        overflow: "hidden auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    } }, paidClaims.map((claim) => (React.createElement("div", { style: {
                        marginBottom: "1em",
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%"
                    } },
                    React.createElement("p", { style: {
                            maxWidth: "10em",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            marginRight: "1em"
                        } }, claim.inventory.name),
                    React.createElement(select_1.MaterialSelect, { label: "Reason for Canceling", required: true, value: (!!this.cancelReasonMulti &&
                            this.cancelReasonMulti[claim.id]) ||
                            "", onSelect: (v) => {
                            this.cancelReasonMulti[claim.id] = v;
                            this.cancelReasonMulti = Object.assign({}, this.cancelReasonMulti);
                        }, searchable: true, options: reasons })))))),
                React.createElement(checkbox_1.MaterialCheckbox, { label: "Same Reason for All Meds", checked: this.useSameReason, onAction: () => {
                        this.useSameReason = !this.useSameReason;
                        this.cancelReason = null;
                        this.cancelReasonMulti = {};
                    } })));
            return (this.doNotDispense && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Go Back", message: this.containsMixStatus
                    ? `You've clicked <strong>Cancel Claim</strong>; this claim order contains mix statuses. This action will reverse
          and cancel <strong>all non-intent associated medications</strong> within the visible claim.
          This can't be undone!<br /><br />`
                    : `You've clicked <strong>Cancel Claim</strong>; this action will reverse
          and cancel <strong>all associated medications</strong> within the visible claim.
          This can't be undone!<br /><br />`, addinModal: renderReason, onCancel: this.onClickCancelDoNotDispense, onConfirm: this.onClickConfirmDoNotDispense, title: "Cancel Claim - Confirmation", shouldDisableConfirm: (!this.cancelReason &&
                    Object.keys(this.cancelReasonMulti).length === 0) ||
                    store_2.ordersStore.order.loading })));
        };
        this.renderModalBeforeDispense = () => this.aboutToDispense && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: this.noClaimsSelected ? "Void Approved Meds" : "Dispense Meds", cancelText: this.noClaimsSelected ? "Return to Select" : "Edit Selection", message: this.noClaimsSelected
                ? "You have not selected a claim. Continuing to dispense will void all approved meds for this patient. Are you sure you want to continue?"
                : `<p>You are about to dispense the following medications for your patient; please ensure your selections are correct and click "dispense" to continue.</p>`, onCancel: this.onClickCancelDispense, onConfirm: this.onClickDispense, shouldDisableConfirm: !this.siteHasPic, title: this.noClaimsSelected ? "No claims selected" : "Dispense Confirmation", selectedClaims: mobx_1.toJS(this.selectedClaims), claimsModal: true, redirect: !this.siteHasPic ? (React.createElement("p", { style: { marginTop: 0 } },
                "Pharmacies ",
                React.createElement("b", null, "must"),
                " have a provider in charge.",
                React.createElement("br", null),
                store_1.usersStore.permissions.UpdatePharmacy && (React.createElement("span", null,
                    React.createElement("a", { className: "pharmLink", onClick: () => router_1.RouteManager.transitionTo(`/pharmacies/${this.order &&
                            this.order.site &&
                            this.order.site.id}`) }, "Click here"),
                    " ",
                    "to modify the pharmacy's settings.")))) : null }));
        this.renderModalBeforeRequest = () => this.aboutToRequest && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: this.noClaimsSelected ? "Void Approved Meds" : "Request Dispense", cancelText: this.noClaimsSelected ? "Return to Select" : "Edit Selection", message: this.noClaimsSelected
                ? "You have not selected a claim. Continuing to dispense will void all approved meds for this patient. Are you sure you want to continue?"
                : `<p>You are requesting an approval for the selected meds. In the following step, a lot number and expiration date will be required for
            each medication before an audit approval can be submitted.</p>`, onCancel: this.onClickCancelRequest, onConfirm: this.onClickRequest, title: this.noClaimsSelected ? "No Claims Selected" : "Request Confirmation", selectedClaims: mobx_1.toJS(this.selectedClaims), claimsModal: true, shouldDisableConfirm: !this.provider.signature || !this.siteHasPic, addinModal: !this.noClaimsSelected && this.renderPadSelection(), redirect: !this.siteHasPic ? (React.createElement("p", { style: { marginTop: 0 } },
                "Pharmacies ",
                React.createElement("b", null, "must"),
                " have a provider in charge.",
                React.createElement("br", null),
                store_1.usersStore.permissions.UpdatePharmacy && (React.createElement("span", null,
                    React.createElement("a", { className: "pharmLink", onClick: () => router_1.RouteManager.transitionTo(`/pharmacies/${this.order &&
                            this.order.site &&
                            this.order.site.id}`) }, "Click here"),
                    " ",
                    "to modify the pharmacy's settings.")))) : null }));
        this.renderModalPrint = () => this.printModal && (React.createElement("div", { className: "pdf-container" },
            React.createElement("div", { className: "pdf-item" },
                !store_2.ordersStore.pdfPreview && (React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "pdfloader" })),
                store_2.ordersStore.pdfPreview && (React.createElement("iframe", { className: "iframe-style", src: store_2.ordersStore.pdfPreview || "/defaultPDF.pdf" }))),
            React.createElement(button_1.MaterialButton, { secondary: true, onClick: () => this.closePrintPreview() }, "Close")));
        this.withPadding = true;
        this.addTab("Dispense", () => `/claims/${Number(this.props.params[0])}`, /^\/claims\/(\d+)$/, () => (React.createElement(dispense_1.DispenseTab, { forwardedRef: this.orderClaimsComponent, params: this.props.params, isClaimChecked: this.isClaimChecked, handleClaimChanged: this.handleClaimChanged, handleClaimSelected: this.handleClaimSelected, handleCheckAllClaims: this.handleCheckAllClaims, isAllClaimsChecked: this.isAllClaimsChecked, indeterminate: this.indeterminate })));
        // B-061 2024-04-24 17:27:38
        const isClinicProvider = store_1.usersStore.user.value.groupId === 9;
        {
            !isClinicProvider && (this.addTab("Process Payments", () => `/claims/${Number(this.props.params[0])}/payment`, /^\/claims\/(\d+)\/payment(s)?\/?$/, () => React.createElement(payment_1.PaymentTab, { params: this.props.params, order: this.order }), () => !!this.order &&
                (this.order.auditStatus === order_1.AuditStatus.Approved ||
                    window.location.href.includes("payment"))));
        }
    }
    /** D-002.810 — when copay collection is off, treat as paid (legacy dispense labels). */
    get copayCollectionEnabled() {
        return patient_payment_balance_1.isCopayCollectionEnabled(this.allowPharmacySetting, this.allowCompanyPatientAmt);
    }
    /** Recomputes when ordersStore.order updates (e.g. after payment tab refresh). */
    get isPaymentComplete() {
        var _a;
        if (!this.copayCollectionEnabled) {
            return true;
        }
        const order = store_2.ordersStore.order.value;
        if (!((_a = order === null || order === void 0 ? void 0 : order.claims) === null || _a === void 0 ? void 0 : _a.length)) {
            return false;
        }
        return patient_payment_balance_1.isOrderPaymentComplete(order.claims);
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    async componentDidMount() {
        /** This entire dispense page needs to be sliced out of this parent component
         * and moved into its respective dispense.tsx file; until that's done, leave
         * the window.loaction check below alone. If it's not here, the order will
         * end up loading multiple times slowing down the page.
         * D-002 new
         */
        var _a, _b, _c, _d;
        this.cancellationReasons = await store_3.appSettingsStore.readCancellations();
        this.showTabs(true);
        const orderId = Number(this.props.params[0]);
        if (orderId) {
            await store_2.ordersStore.loadClaims(orderId, undefined, false, true);
            await store_2.ordersStore.readOrder(orderId);
            const order = (_a = store_2.ordersStore === null || store_2.ordersStore === void 0 ? void 0 : store_2.ordersStore.order) === null || _a === void 0 ? void 0 : _a.value;
            const companyInfo = await store_5.inventoryOrderStore.loadSiteComapnyDetailsInfo(order.site.id); // D-002.8
            this.allowCompanyPatientAmt = companyInfo[0].allowCompanyCopayCollection == 1 ? true : false; // D-002.8
            this.allowPharmacySetting = !!((_b = order === null || order === void 0 ? void 0 : order.site) === null || _b === void 0 ? void 0 : _b.allowSiteCopayCollection);
            this.allowCompanyForEsign = companyInfo[0].allowUsersForEsign == 1 ? true : false; // C-108
            this.provider = order.provider;
            this.order = order;
            this.orderStatus = order === null || order === void 0 ? void 0 : order.status;
            this.auditStatus = order === null || order === void 0 ? void 0 : order.auditStatus;
            this.provider = await store_4.providersStore.readProvider(this.provider.id);
            this.renderAlertRefill(order);
            store_4.providersStore.loadActivePads(this.provider);
            window.clearInterval(this.loadOrderInterval);
            this.loadOrderInterval = window.setInterval(async () => {
                if (this.orderStatus === order_1.OrderStatus.Pending ||
                    this.orderStatus === order_1.OrderStatus.Progress ||
                    this.orderStatus === order_1.OrderStatus.Executing) {
                    const orderId = Number(this.props.params[0]);
                    await store_2.ordersStore.loadClaims(orderId, undefined, true, true);
                    const newOrder = store_2.ordersStore.order.value;
                    const newStatus = newOrder === null || newOrder === void 0 ? void 0 : newOrder.status;
                    this.orderStatus = newStatus;
                    this.renderAlertRefill(newOrder);
                }
                // }, 2500);
            }, 10000);
        }
        else {
            this.showTabs(false);
        }
        this.currentDropValue = (_d = (_c = this.order) === null || _c === void 0 ? void 0 : _c.site) === null || _d === void 0 ? void 0 : _d.allowSiteForSelection; // C-108.3
    }
    componentWillUnmount() {
        store_2.ordersStore.errorAlert = null;
        window.clearInterval(this.loadOrderInterval);
        window.clearInterval(this.signatureInterval);
        window.clearInterval(this.mobileSignatureInterval);
    }
    async componentWillReceiveProps(props) {
        const oldOrderId = Number(this.props.params[0]);
        const newOrderId = Number(props.params[0]);
        if (newOrderId && oldOrderId !== newOrderId) {
            window.clearInterval(this.loadOrderInterval);
            await store_2.ordersStore.loadClaims(newOrderId, undefined, false, true);
        }
        if (newOrderId) {
            const newOrder = store_2.ordersStore.order.value;
            this.orderStatus = newOrder === null || newOrder === void 0 ? void 0 : newOrder.status;
            this.showTabs(true);
            window.clearInterval(this.loadOrderInterval);
            this.loadOrderInterval = window.setInterval(async () => {
                console.count("load order interval in cwrp triggered ");
                if (this.orderStatus === order_1.OrderStatus.Pending ||
                    this.orderStatus === order_1.OrderStatus.Progress ||
                    this.orderStatus === order_1.OrderStatus.Executing) {
                    const orderId = Number(this.props.params[0]);
                    store_2.ordersStore.loadClaims(orderId, undefined, true, true);
                    await store_2.ordersStore.readOrder(orderId, true);
                    const newOrder = store_2.ordersStore.order.value;
                    const newStatus = newOrder === null || newOrder === void 0 ? void 0 : newOrder.status;
                    this.orderStatus = newStatus;
                    this.renderAlertRefill(newOrder);
                }
                // }, 2500);
            }, 10000);
            this.loadOrderInterval;
            this.isBypassSignature("e_Sign"); // C-108.7
        }
        else {
            this.showTabs(false);
        }
    }
    render() {
        var _a, _b, _c;
        const { order: { value } } = store_2.ordersStore;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "orders-detail", style: { marginBottom: "120px" } },
                this.dispenseScan ? (React.createElement(dispense_scan_1.DispenseScan, { order: this.order, onCancel: () => (this.dispenseScan = false), handleSubmit: this.handleDispenseScanSubmit })) : null,
                store_1.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
                    React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                        React.createElement(kpi_title_1.KpiTitle, { label: value
                                ? `${value.patient.firstName} ${value.patient.lastName}`
                                : "", label2: [permissions_1.GROUPS.DEV, permissions_1.GROUPS.ADMIN].includes((_b = (_a = store_1.usersStore === null || store_1.usersStore === void 0 ? void 0 : store_1.usersStore.user) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.groupId)
                                ? (_c = value === null || value === void 0 ? void 0 : value.site) === null || _c === void 0 ? void 0 : _c.name : "", subLabel: value
                                ? `${moment
                                    .tz(value.createDate, value.site.timezone)
                                    .format("M/D/YY h:mm A z")}`
                                : "", subLabel2: value && this.renderStatus(value), subLabel3: this.order ? (this.order.type ? "Cash" : "Insurance") : "", editPatient: value && (React.createElement("a", { onClick: () => router_1.RouteManager.transitionTo(`/patients/${value.patient.id}`) }, "Edit Patient")) })),
                    React.createElement(floating_page_1.FloatingPage, null,
                        this.renderPatientSignatureAlert(),
                        this.route && (React.createElement("div", { className: "orders-detail__tabs" }, super.render()))),
                    store_1.usersStore.permissions.ReadClaims && this.renderFooter())) : (store_1.usersStore.showLock())),
            React.createElement(ReactTooltip, { effect: "solid", id: "dispensebtn", place: "top", delayShow: 200, "data-type": "info", html: true, multiline: true })));
    }
    /**
     * @desc Loads the state of the current order for processing.
     */
    getOrder() {
        const claims = this.selectedClaims.map(claim => {
            const match = this.changedClaims.find(c => c.id === claim.id);
            if (match) {
                claim.claimLots = match.claimLots;
            }
            return claim;
        });
        const order = {
            claims,
            id: Number(this.props.params[0])
        };
        return order;
    }
    getPadSelector() {
        var _a, _b, _c, _d;
        if (store_1.usersStore.user.value.groupId === 4) {
            return (React.createElement(React.Fragment, null,
                (!store_2.ordersStore.mobilePads.value ||
                    store_2.ordersStore.mobilePads.value.length === 0) && (React.createElement(Menu_1.MenuItem, null, "No Pads Found")),
                store_2.ordersStore.mobilePads.value &&
                    store_2.ordersStore.mobilePads.value.map((p, index) => (React.createElement(Menu_1.MenuItem, { key: index, onClick: () => this.handleMobilePadSelectPatient(p) }, p.name)))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                !((_b = (_a = store_2.ordersStore === null || store_2.ordersStore === void 0 ? void 0 : store_2.ordersStore.pads) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(Menu_1.MenuItem, { onClick: this.handleCreatePad },
                    React.createElement("a", { className: "pad-create-menu-link", href: "/pad", target: "__blank" }, "Click to create"))), (_d = (_c = store_2.ordersStore === null || store_2.ordersStore === void 0 ? void 0 : store_2.ordersStore.pads) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 :
                _d.map((p) => (React.createElement(Menu_1.MenuItem, { key: p.id, onClick: async () => this.handlePadSelectPatient(p) }, p.name)))));
        }
    }
    get siteHasPic() {
        return (this.order &&
            this.order.site &&
            (this.order.site.picProvider || this.order.site.picProviderId));
    }
};
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "dispenseScan", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "padsOpen", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "aboutToDispense", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "aboutToRequest", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "doNotDispense", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "changedClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "selectedClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "checkedAllClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "indeterminateClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "noClaimsSelected", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "printModal", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "isRefill", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "isError", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "cancelReason", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "cancelReasonMulti", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "patientHasSigned", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "auditStatus", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "isSaving", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "containsMixStatus", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "useSameReason", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "cancellationReasons", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "allowCompanyForEsign", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "currentDropValue", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "allowUsersForEsign", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "allowCompanyPatientAmt", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "allowPharmacySetting", void 0);
__decorate([
    mobx_1.observable
], OrdersDetail.prototype, "orderClaimsComponent", void 0);
__decorate([
    mobx_1.computed
], OrdersDetail.prototype, "copayCollectionEnabled", null);
__decorate([
    mobx_1.computed
], OrdersDetail.prototype, "isPaymentComplete", null);
__decorate([
    mobx_1.computed
], OrdersDetail.prototype, "siteHasPic", null);
OrdersDetail = __decorate([
    mobx_react_1.observer
], OrdersDetail);
exports.OrdersDetail = OrdersDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/orders-detail.tsx
// module id = 3743
// module chunks = 0